import * as React from "react";

import { usePlpPresenterForTheSortingMenu } from "../providers";

export const Header: React.FunctionComponent = () => {
  const { handleHideTheSortingMenu_onMobile } = usePlpPresenterForTheSortingMenu();

  return (
    <div className="header">
      <h1>Sort By</h1>
      <div className="button close" onClick={handleHideTheSortingMenu_onMobile} />
    </div>
  );
};
